import React, { Component, Fragment } from 'react';
import Header from '../../components/Header';
import UserAvatar from '../../components/UserAvatar';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import loginService from '../../services/servicesLogin';
import recoverLoginService from '../../services/servicesLoginRecover';
import { authenticate } from '../../store/actions/login';
import ProfileUserData from '../../components/ProfileUserData';
import Dialog from '../../components/Dialog';
import { Input } from 'react-materialize';
import './index.scss';

import { allNotifications } from '../../utils/toastify';
const { notifySuccessBottomRight, notifyErrorBottomRight } = allNotifications;

class UserProfile extends Component {
  modalResultChangedPassword = React.createRef();

  state = {
    valueInputDdd: '',
    valueInputPhone: ''
  };

  constructor(props) {
    super(props);
  }

  notify = message => {
    notifyErrorBottomRight(message);
  };

  changePassModal = async () => {
    try {
      this.modalResultChangedPassword.current.setState({ modalActive: true });
    } catch (err) {
      this.notify(err.message);
    }
  };

  render() {
    return (
      <div className="UserProfile">
        <div className="UserProfile__box">
          <Header name="Perfil" class="title-center" />
          <UserAvatar bgClass="" />
        </div>

        <div className="UserProfile__content">
          <ProfileUserData />
        </div>
        <Dialog
          ref={this.modalResultChangedPassword}
          header="Alteração de senha solicitada"
          buttons={[
            {
              title: 'Fechar',
              callback: () =>
                this.modalResultChangedPassword.current.setState({ modalActive: false })
            },
            {
              title: 'Confirmar',
              callback: () => this.resetPassword()
            }
          ]}
        >
          <Fragment>
            <div className="change-pass-box">
              <p>Preencha os dados abaixo para efetuar a troca da senha</p>

              <div className="input-field">
                <Input
                  label="Senha atual"
                  type="password"
                  onChange={this.handleChangeInputOldPassword}
                />
              </div>
              <div className="input-field">
                <Input
                  label="Nova senha"
                  type="password"
                  onChange={this.handleChangeInputNewPassword}
                />
              </div>
              <div className="input-field">
                <Input
                  label="Confirmar senha"
                  type="password"
                  onChange={this.handleChangeInputConfirmPassword}
                />
              </div>
              <div className="input-field">
                <Input
                  label="DDD"
                  type="number"
                  value={this.state.valueInputDdd}
                  onChange={this.handleChangeInputDdd}
                  onKeyDown={evt =>
                    evt.keyCode == 8 || evt.keyCode == 46
                      ? false
                      : (evt.key === 'e' ||
                          evt.key === '.' ||
                          evt.key === ',' ||
                          evt.key === '-' ||
                          isNaN(evt.key)) &&
                        evt.preventDefault()
                  }
                />
              </div>
              <div className="input-field">
                <Input
                  label="Celular"
                  type="number"
                  value={this.state.valueInputPhone}
                  onChange={this.handleChangeInputPhone}
                  onKeyDown={evt =>
                    evt.keyCode == 8 || evt.keyCode == 46
                      ? false
                      : (evt.key === 'e' ||
                          evt.key === '.' ||
                          evt.key === ',' ||
                          evt.key === '-' ||
                          isNaN(evt.key)) &&
                        evt.preventDefault()
                  }
                />
              </div>
            </div>
          </Fragment>
        </Dialog>
      </div>
    );
  }

  handleChangeInputOldPassword = event => {
    this.setState({
      valueInputOldPassword: event.target.value
    });
  };

  handleChangeInputNewPassword = event => {
    this.setState({
      valueInputNewPassword: event.target.value
    });
  };

  handleChangeInputConfirmPassword = event => {
    this.setState({
      valueInputConfirmPassword: event.target.value
    });
  };

  handleChangeInputDdd = event => {
    this.setState({
      valueInputDdd:
        event.target.value.length > 2 ? event.target.value.slice(0, 2) : event.target.value
    });
  };

  handleChangeInputPhone = event => {
    this.setState({
      valueInputPhone:
        event.target.value.length > 9 ? event.target.value.slice(0, 9) : event.target.value
    });
  };

  resetPassword = () => {
    const codigo = this.props.codigo;
    const senha = this.state.valueInputOldPassword;
    const novaSenha = this.state.valueInputNewPassword;
    const confirmarSenha = this.state.valueInputConfirmPassword;
    const ddd = this.state.valueInputDdd;
    const celular = this.state.valueInputPhone;

    if (confirmarSenha !== novaSenha) {
      this.notify('As senhas digitadas não conferem');
      return;
    }

    const params = {
      codigo: codigo,
      ddd: ddd,
      celular: celular,
      newPassword: novaSenha
    };

    if (
      senha === '' ||
      params.codigo === '' ||
      params.ddd === '' ||
      params.celular === '' ||
      params.newPassword === ''
    ) {
      this.notify('Todos os campos são obrigatórios');
      return;
    }

    const isCpfCnpj = false;

    loginService
      .loginAPI(codigo, senha, isCpfCnpj)
      .then(() => {
        recoverLoginService
          .wsloginRecover(codigo)
          .then(data => {
            recoverLoginService
              .newLogin(params)
              .then(data => {
                this.modalResultChangedPassword.current.setState({ modalActive: false });
                notifySuccessBottomRight('Senha alterada com sucesso!');
              })
              .catch(error => {
                error.data
                  ? this.notify(error.data.descricao)
                  : this.notify('Erro ao alterar a senha');
              });
          })
          .catch(() => {
            this.notify('Erro ao desativar usuário');
          });
      })
      .catch(() => {
        this.notify('Senha incorreta');
      });
  };
}

UserProfile.propTypes = {
  codigo: PropTypes.number.isRequired,
  email: PropTypes.string.isRequired
};

const mapStateToProps = ({ login }) => ({
  codigo: login.user.codigo,
  email: login.user.email
});

export default connect(mapStateToProps, { authenticate })(UserProfile);
